import Apps from './Apps';
import Updates from './Updates';

export default {
  Apps,
  Updates,
};
